import styled from 'styled-components';
import { Box } from '@components/Box';
import { TextBackgroundPhoto } from '@components/TextBackgroundPhoto';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { StyledButton } from '@components/Button';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';

export const PersonalTravelConciergeSectionWrapper = styled(Box)`
  position: relative;
  min-height: 1104px; // Revisar en que breakpoints resulta mejor bajarlo un poco.
  overflow: hidden;
  @media (min-width: 835px) and (max-width: 1151px) {
    min-height: 950px;
  }
`;

export const StyledBackgroundPhoto = styled(TextBackgroundPhoto)`
  padding-bottom: 0px;
  box-sizing: border-box;
  ${themeMediaQuery('below_sm')} {
    background-size: contain;
  }
`;

export const HeroTextContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
  ${themeMediaQuery('below_sm')} {
    padding-top: 100px;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    padding-top: 100px;
  }
  /* padding-top: 10rem;
  ${themeMediaQuery('lg')} {
    padding-top: 20rem;
  } */
`;

export const StyledHeroTextColumn = styled(Columns)``;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 416px;
    margin-bottom: 24px;
    font-size: 56px;
    line-height: 68px;
  }
  .text-pairing-body {
    width: 680px;
    max-width: 680px;
    font-size: 20px;
    line-height: 32px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      font-size: 40px;
      line-height: 46.88px;
    }
    .text-pairing-body {
      width: auto;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      width: auto;
      max-width: 500px;
    }
  }
`;

export const StyledGetStartedButton = styled(GetStartedButton)`
  margin-top: 24px;
`;
